<template>
    <div class="center_order_status_box">
        <!-- 标题 -->
        <center-title>{{$t("message.costatus.title2")}}</center-title>
        <!-- 标签页 -->
        <order-search
            :tabs="tabs"
            :handle-download="handlePayStatusExcel"
			handle="index/orderstatus/order_excel"
			@handle-export="conditionsExport"
            @handle-search="getData(sortAttr, sortMode)">
        </order-search>
        <!-- 表格部分 -->
        <order-status-table
			:type="1"
            :get-detail="getPayStatusDetail"
            :prop-attr="sortAttr"
            :order="sortMode"
			@selection-change="handleSelectionChange"
            :current-page="page.current_page"
            :page-count="page.last_page"
            @handleSort="handleSort"
			@handle-export="conditionsExport"
            @current-change="handleCurrent">
            <template #branch>
                <el-table-column
                    label="子公司/分行"
                    prop="branchname"
                    align="center"
                    min-width="120"
                    sortable="custom">
                </el-table-column>
            </template>
        </order-status-table>
        <!-- 模态框 -->
        <order-status-dialog></order-status-dialog>
    </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex'
import { tableRouterView } from "@/utils/publicMethod.js";

export default {
    mixins: [ tableRouterView ],
    data() {
        return {
            tabs: [ // 标签页参数
                {
                    label: this.$t("message.costatus.tabs1"),
                    name: "9",
                },
                {
                    label: this.$t("message.costatus.tabs10"),
                    name: "0",
                },
                // {
                //     label: this.$t("message.costatus.tabs11"),
                //     name: "10",
                // },
                {
                    label: this.$t("message.costatus.tabs12"),
                    name: "20",
                },
                {
                    label: this.$t("message.costatus.tabs13"),
                    name: "30",
                }
            ]
        }
    },
    computed: mapState({
        power: state => state.user.power,
        islogin: state => state.user.islogin,
        character_id: state => state.user.character_id,
        order_tabs: state => state.order.order_tabs,
        page: state => state.user.page
    }),
    components: {
        centerTitle: () => import("@/components/center/centerTitle"),
        orderSearch: () => import("@/components/center/orderSearch"),
        orderStatusTable: () => import("@/components/center/orderStatusTable"),
        orderStatusDialog: () => import("@/components/center/orderStatusDialog"),
    },
    methods: {
        ...mapMutations([
            "setOrderList",
            "setOrderTabs",
            "handleDialog",
            'setPage'
        ]),
        ...mapActions([
            "getOrderDepartment",
            "getPayStatusList",
            "handlePayStatusExcel",
            "getPayStatusDetail"
        ]),
		//按条件导出
		conditionsExport(){
			let order_sn = sessionStorage.getItem('order_sn') || '',
			    release = sessionStorage.getItem('release') || '',
			    relend = sessionStorage.getItem('relend') || '',
			    department = sessionStorage.getItem('department') || '',
			    user_id = sessionStorage.getItem('member') || '';
			
			let list = this.selectedList.map(element => {
				return element.order_id
			});
			let id = list.join();
			let url = this.$URL.baseUrl + "index/orderstatus/order_excel?lang=cn&order_id=" + id + '&order_sn=' + order_sn + '&release=' + release + '&relend=' + relend + '&department=' + department + '&user_id=' +  user_id;                        
			console.log(url)
			window.open(url);
		},
		//導出
		handleExport() {
			let list = this.selectedList.map(element => {
				return element.order_id
			});
			if (list.length == 0) {
				this.$message({
					showClose: true,
					message: '請選擇導出訂單',
					type: "error"
				})
				return
			}
			let id = list.join();
			let url = this.$URL.baseUrl + "index/orderstatus/order_excel?lang=cn&order_id=" + id;
			window.open(url);
		},
        getData(attr, mode, page = 1) {
            let order_sn = sessionStorage.getItem('order_sn') || '',
                release = sessionStorage.getItem('release') || '',
                relend = sessionStorage.getItem('relend') || '',
                department = sessionStorage.getItem('department') || '',
                user_id = sessionStorage.getItem('member') || '';

            this.getOrderDepartment();
            this.getPayStatusList({
                order_sn,
                release,
                relend,
                department,
                user_id,
                attr,
                mode,
                page
            })
        },
        changeRouter(search, attr, mode, page = 1) {
            this.$router.push({
                name: 'payStatus',
                query: {
                    attr,
                    mode,
                    page
                }
            }).catch(err => err)
        }
    },
    beforeRouteEnter (to, from, next) {
        next(vm => {
			// vm.character_id !== 5 &&
            // let allow =  vm.character_id !== 6,
			setTimeout(() => {
				let allow = vm.power.includes(0) ||  vm.power.includes(12) ||  vm.power.includes(111),
				    {
				        attr = '',
				        mode = '',
				        page = 1
				    } = to.query;
				if(allow){
				    vm.getData(attr, mode, page);
				}else{
				    vm.$message({
				        showClose: true,
				        message: vm.$t("message.costatus.errmsg1"),
				        type: "error"
				    })
				    vm.$router.back();
				    return false;
				}
			}, 500)
        })
    },
    beforeRouteUpdate(to, from, next) {
        let {
            attr = '',
            mode = '',
            page = 1
        } = to.query;
        
        this.getData(attr, mode, page);
        next();
    },
    beforeRouteLeave (to, from, next) {
        this.setOrderTabs("9");
        this.setOrderList([]);
        this.setPage({});
        this.handleDialog(false);
        sessionStorage.removeItem("order_tabs");
        sessionStorage.removeItem("order_sn");
        sessionStorage.removeItem("release");
        sessionStorage.removeItem("relend");
        sessionStorage.removeItem("department");
        sessionStorage.removeItem("member");
        next();
    }
}
</script>